import * as types from 'constants/ActionTypes';
import initialState from 'config/initialState';

export default function auth(state = initialState.pages, action) {
  const bySlug = {};

  switch (action.type) {

    case types.PAGE: {
      const page = action.data;
      bySlug[page.slug] = Object.assign({}, state.bySlug[page.slug] || null, page, {
        loaded: true,
      });
      return Object.assign({}, state, {
        bySlug: Object.assign({}, state.bySlug, bySlug),
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/PageReducers.js